import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';
import { ActivityTypeEnums } from '../models/enums/ActivityType';
import { IGetContents } from '../models/action/madlenIntegration';

let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const T = Translator.create();

export class MadlenIntegrationService {
    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestGetActivitiesForMadlenAsync(params: any) {

        const query = `${params.CourseId}/${params.ClassId}?termWeekId=${params.TermWeekId ? params.TermWeekId : 0}&activityTypes=${ActivityTypeEnums.Video}&ActivityTypes=${ActivityTypeEnums.Document}&ActivityTypes=${ActivityTypeEnums.VirtualClass}&weekZero=${params.weekZero}&isWeekly=${params.IsWeekly}&take=${params.Take}&skip=${params.Skip}&orderBy=${params.OrderBy}`;
        const requestUrl = `api/activity/byweekactivity/` + query;

        return _apiClient.RequestAsync('GET', requestUrl, null, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetActivitiesContentForMadlenAsync(params: any) {
        return _apiClient.RequestAsync('GET', `api/ai/contents?courseId=${params.CourseId}&page=1&take=10&skip=${params.Skip}&orderByAsc=false`, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestCreateSendContentJob(params: any) {
        return _apiClient.RequestAsync('POST', 'api/ai/create-send-content-job', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestMadlenSendContentAI(params: any) {
        return _apiClient.RequestAsync('POST', 'api/ai/send-content', params, '', false)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetAIContentsAsync(params: IGetContents) {
        return _apiClient.RequestAsync('GET', `api/ai/contents?courseId=${params.CourseId}&status=${params.Status}&take=${params.Take}&page=${params.Page}&orderByAsc=${params.OrderByAsc}`, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetMadlenUrlAsync() {
        return _apiClient.RequestAsync('GET', 'api/ai/get-madlen-url', null, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

}